import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { of, switchMap, take } from 'rxjs';
import { ModalLoginComponent } from 'src/app/routes/auth/modals/modal-login/modal-login.component';
import { AuthRepository } from 'src/app/routes/auth/state/auth.repository';
import { OverlayService } from '../services/overlay.service';

export function authGuard({
  isProtected = true,
}: {
  isProtected?: boolean;
}): CanMatchFn {
  return () => {
    const platformId = inject(PLATFORM_ID);

    if (isPlatformServer(platformId)) {
      return of(true);
    }

    const authRepository = inject(AuthRepository);
    const router = inject(Router);
    const overlayService = inject(OverlayService);

    const currentUrl = router.url;

    return authRepository.token$.pipe(
      take(1),
      switchMap((token) => {
        if (isProtected) {
          if (token) {
            return of(true);
          } else {
            overlayService.open(
              {
                width: 434,
                hasBackdrop: true,
                backdropClass: 'backdrop-style',
                responsive: true,
              },
              ModalLoginComponent
            );
            return of(router.createUrlTree([currentUrl]));
          }
        } else {
          return !token ? of(true) : of(router.createUrlTree([currentUrl]));
        }
      })
    );
  };
}
